var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"myCharts",attrs:{"id":"myCharts"}})}
var staticRenderFns = []

export { render, staticRenderFns }